import { render, staticRenderFns } from "./AdminLogView.vue?vue&type=template&id=0a92b9fa&"
import script from "./AdminLogView.vue?vue&type=script&lang=ts&"
export * from "./AdminLogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports